import React from 'react';
import {assert} from 'assert-ts';
import type {PartAction} from 'schemaDefinition/types';
import type {DataFormActionProps} from './types';
import {MultiThesaurusAction} from './actions';

export const DataFormAction: React.FC<DataFormActionProps<PartAction>> = ({
  action,
  ...props
}) => {
  switch (action.actionName) {
    case 'multiThesaurus':
      return (
        <MultiThesaurusAction key={action.role} {...props} action={action} />
      );
    default:
      assert(
        false,
        `DataFormAction: Unknown action type: ${action.actionName}`,
      );
  }
};
